import { KeyboardArrowDownRounded } from "@mui/icons-material";
import { Select, useTheme } from "@mui/material";
import React from "react";

// Custom select component for the share dialog with specific styling. Reused throughout ShareDialog
export const ShareDialogSelect = <T,>({
    children,
    value,
    onChange,
    id,
}: {
    children: React.ReactNode;
    value: T;
    onChange: (value: T) => void;
    id?: string;
}) => {
    const theme = useTheme();
    return (
        <Select
            className="fixPadding"
            id={id}
            value={value}
            onChange={(e) => {
                onChange(e.target.value as T);
            }}
            variant="outlined"
            sx={{
                border: "none",
                color: theme.palette.primary.main,
                fontSize: "14px",
                fontWeight: theme.typography.fontWeightSemibold,
                background: "none",
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                },
            }}
            MenuProps={{
                PaperProps: {
                    sx: {
                        mt: 1,
                        boxShadow: 3,
                    },
                },
            }}
            inputProps={{
                sx: {
                    paddingRight: "0px !important",
                },
            }}
            IconComponent={() => (
                <KeyboardArrowDownRounded
                    fontSize="small"
                    sx={{
                        backgroundColor: "transparent",
                        color: theme.palette.primary.main,
                        paddingRight: "0px",
                    }}
                />
            )}
        >
            {children}
        </Select>
    );
};
